module.exports = __webpack_public_path__ + "img/box-shadow.d2414f52.svg";